/**
 * Parse an activity_date string from the API into a timezone-aware Date.
 * The API emits naive UTC strings in two forms:
 *   - "YYYY-MM-DD HH:MM:SS"       (space-separated, Django templatetag)
 *   - "YYYY-MM-DDTHH:MM:SS.sss"   (ISO-ish, no offset, DRF serializer)
 * Strings that already carry a UTC marker (Z) or an explicit offset (+/-HH:MM)
 * are passed through as-is.
 */
export function parseActivityDate(raw) {
    const normalized = raw.replace(' ', 'T');
    const hasTimezone = /(Z|[+-]\d{2}:\d{2})$/.test(normalized);
    return new Date(hasTimezone ? normalized : `${normalized}Z`);
}
export function normalizeRegistrationActivity(raw) {
    return { ...raw, activity_date: parseActivityDate(raw.activity_date) };
}
